import React, { ChangeEvent, FC, useState } from 'react';

import cx from 'classnames';
import { isNil, prop } from 'ramda';

import BaseTextArea from 'components/shared/FormAdapters/FormBase/TextArea';

import Text from '../../../Typography/Text';
import styles from './index.module.css';
import { IDefaultTextareaProps } from './types';

const DefaultTextarea: FC<IDefaultTextareaProps> = ({
  size,
  isError,
  disabled,
  postfix,
  maxLength,
  hideMaxLength = false,
  onChange,
  className,
  onFocus,
  onBlur,
  spellCheck,
  withBackground,
  value,
  ...props
}) => {
  const defaultTextareaContainerClasses = cx(
    styles.textareaContainer,
    size && prop(`textareaContainer-${size}`, styles),
    disabled && prop('textareaContainer-disabled', styles),
    isError && prop('textareaContainer-isError', styles),
    'custom-input-textarea-container',
    disabled && 'custom-input-textarea-container-disabled',
    isError && 'custom-input-textarea-container-isError',
  );
  const textareaClasses = cx(
    styles.textarea,
    className,
    withBackground && prop('textarea-withBackground', styles),
    'custom-input-textarea',
  );
  const [isFocused, setIsFocused] = useState(false);

  const handleChange = (evt: ChangeEvent<HTMLTextAreaElement>) => {
    if (maxLength! > 0) {
      evt.target.value = evt.target.value.slice(0, maxLength);
    }

    onChange && onChange(evt);
  };
  //@ts-ignore
  const handleFocus = (...args) => {
    setIsFocused(true);
    //@ts-ignore
    onFocus && onFocus(...args);
  };
  //@ts-ignore
  const handleBlur = (...args) => {
    setIsFocused(false);
    //@ts-ignore
    onBlur && onBlur(...args);
  };

  return (
    <div className={defaultTextareaContainerClasses}>
      <BaseTextArea
        {...props}
        onFocus={handleFocus}
        onBlur={handleBlur}
        onChange={handleChange}
        className={textareaClasses}
        disabled={disabled}
        spellCheck={isNil(spellCheck) ? isFocused : spellCheck}
        value={value}
      />
      {postfix && <div className={styles.postfix}>{postfix}</div>}
      {maxLength && !hideMaxLength && (
        <div className={styles.maxLength}>
          <Text className={styles.color} accent size="small">{`${value.length}/${maxLength}`}</Text>
        </div>
      )}
    </div>
  );
};

export default DefaultTextarea;
